import React, { Component } from 'react';
import {BrowserRouter as Router,Switch,Route,Link} from "react-router-dom";

class Nav extends Component {
  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top bg-transparent">
  {/*       menufixedtop là định nghĩa thêm, add vào khi cuộn chuột*/}
  <div className="container-fluid">
    <a className="navbar-brand" href="#"><img className="logo" src="images/googlelogo_light_color_112x36dp.png" alt />Drive </a>
    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon" />
    </button>
    <div className="collapse navbar-collapse" id="navbarResponsive">
      <div className="d-none">
        <img src="images/logo-drive.png" alt />
      </div>
      <ul className="navbar-nav ml-auto">
        <li className="nav-item active">
          <Link className="nav-link" to="/">Home<span className="sr-only">(current)</span></Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/usingdrive">Using Drive</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/download">Download</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/forbusiness">For Business</Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/help">Help</Link>
        </li>
        <li className="nav-item goto d-none">
          <a className="nav-link" to="#">Go to Google Drive</a>
        </li>
      </ul>
      <button type="button" className="btn btn-info d-none">Sign In</button> {/* nút này mặc định ẩn, chỉ hiện ra trong giao diện Mobile */}
    </div>
  </div>
</nav>

    );
  }
}

export default Nav;